import ApplicationSerializer from "./application";
import { EmbeddedRecordsMixin } from "@ember-data/serializer/rest";

export default class LoadBalancerListenerSerializer extends ApplicationSerializer.extend(EmbeddedRecordsMixin) {
  attrs = {
    backend: {
      serialize: false,
    },
    targets: {
      embedded: "always",
    },
    loadBalancer: {
      serialize: false,
    },
  };
}
